import { render, staticRenderFns } from "./MetaboliteTooltip.vue?vue&type=template&id=22ba6291&scoped=true"
import script from "./MetaboliteTooltip.vue?vue&type=script&lang=js"
export * from "./MetaboliteTooltip.vue?vue&type=script&lang=js"
import style0 from "./MetaboliteTooltip.vue?vue&type=style&index=0&id=22ba6291&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba6291",
  null
  
)

export default component.exports